import { apiClient } from './apiClient';
import { 
  CorrectionInvoice, 
  CreateCorrectionInvoiceRequest, 
  CorrectionInvoiceStatus 
} from '../types/correctionInvoice';
import { Language } from '../types/language';

export const correctionInvoiceService = {
  // Создать корректировочный счет-фактуру
  createCorrectionInvoice: async (companyId: string, request: CreateCorrectionInvoiceRequest): Promise<CorrectionInvoice> => {
    const response = await apiClient.post(`/companies/${companyId}/correction-invoices`, request);
    return response.data;
  },

  // Получить корректировочный счет по ID
  getCorrectionInvoice: async (companyId: string, correctionInvoiceId: string): Promise<CorrectionInvoice> => {
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices/${correctionInvoiceId}`);
    return response.data;
  },

  // Получить список корректировочных счетов
  getCorrectionInvoices: async (companyId: string, page: number = 0, size: number = 20): Promise<{
    content: CorrectionInvoice[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
  }> => {
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices`, {
      params: { page, size }
    });
    return response.data;
  },

  // Получить корректировочные счета по оригинальному счету
  getCorrectionInvoicesByOriginalInvoice: async (companyId: string, originalInvoiceId: string): Promise<CorrectionInvoice[]> => {
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices/by-original-invoice/${originalInvoiceId}`);
    return response.data;
  },

  // Обновить статус корректировочного счета
  updateStatus: async (companyId: string, correctionInvoiceId: string, status: CorrectionInvoiceStatus): Promise<CorrectionInvoice> => {
    const response = await apiClient.put(`/companies/${companyId}/correction-invoices/${correctionInvoiceId}/status`, null, {
      params: { status }
    });
    return response.data;
  },

  // Удалить корректировочный счет
  deleteCorrectionInvoice: async (companyId: string, correctionInvoiceId: string): Promise<void> => {
    await apiClient.delete(`/companies/${companyId}/correction-invoices/${correctionInvoiceId}`);
  },

  // Предварительный просмотр номера корректировочного счета (без инкрементации счетчика)
  previewCorrectionNumber: async (companyId: string, correctionDate?: string): Promise<{ correctionNumber: string }> => {
    const params = correctionDate ? `?correctionDate=${correctionDate}` : '';
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices/preview-number${params}`);
    return response.data;
  },

  // Генерировать номер корректировочного счета (инкрементирует счетчик)
  // @deprecated Используйте previewCorrectionNumber для предварительного просмотра
  generateCorrectionNumber: async (companyId: string, correctionDate?: string): Promise<{ correctionNumber: string }> => {
    const params = correctionDate ? `?correctionDate=${correctionDate}` : '';
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices/generate-number${params}`);
    return response.data;
  },

  // Скачать PDF корректировочного счета
  downloadCorrectionInvoicePdf: async (companyId: string, correctionInvoiceId: string, correctionNumber: string, clientName: string, language: Language = Language.PL_ONLY): Promise<void> => {
    const response = await apiClient.get(`/companies/${companyId}/correction-invoices/${correctionInvoiceId}/pdf?language=${language}`, {
      responseType: 'blob'
    });
    
    // Создаем ссылку для скачивания
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    // Очищаем имя клиента от недопустимых символов для имени файла
    const cleanClientName = clientName.replace(/[^a-zA-Z0-9а-яА-Я\s-]/g, '').replace(/\s+/g, '-');
    link.setAttribute('download', `${correctionNumber}-${cleanClientName}-${language.toLowerCase()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
};

